var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M6.707 5.293a1 1 0 0 0-1.414 1.414L15.586 17H7a1 1 0 1 0 0 2h11a1 1 0 0 0 1-1V7a1 1 0 1 0-2 0v8.586z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }